import type { ReactNode } from 'react';

import { formLabelClassName } from '@/features/original-plus/components/OriginalPlusApplicationForm/original-plus-application-form.style';

type FormFieldLabelProps = {
  htmlFor: string;
  required?: boolean;
  children: ReactNode;
};

export function FormFieldLabel({ htmlFor, required, children }: FormFieldLabelProps) {
  return (
    <label htmlFor={htmlFor} className={formLabelClassName}>
      {children}
      {required ? <span className="text-[#A8EA3A]"> *</span> : null}
    </label>
  );
}
